import { linuxImages } from "../utils/imageImports"; // linuxImagesをインポート

// GuestMaterialType型を定義
export type GuestMaterialType = {
    title: string;
    header?: string;
    imgPath?: string;
    text?: string[];
    width?: string;
    unindex?: boolean;
    objId?: number;
    obj?: JSX.Element | null;
};

// 定数を定義
export const NO_1 = '1';
export const NO_2 = '2';

// タイトルを格納するオブジェクト
export const titles = {
    [NO_1]: "Linuxコマンド入門",
    [NO_2]: "認知特性テスト"
};

// Linuxコマンド資料の内容（タイトル、画像、説明など）をリストとして定義
export const dataForNo1: GuestMaterialType[] = [
    {
        title: "Lesson0-解説-",
        header: "〇",
    },
    {
        title: "①このサイトで紹介しているコマンドや内容に関して",
        text: [
            "このサイトでは、研修で実施する「Linuxコマンド」の一部を紹介しています。",
            "これにより、入社後の研修や業務で使用する技術の第一歩を実際に体験することができます。",
            "ただし、Linuxコマンドを正しく実行するには、Linux環境を構築する必要があります。",
            "Linux環境の構築には多くの知識が必要です。",
            "このサイトではWindows OSでLinuxコマンドを疑似的に体験できるようにしています。",
            "「Linuxではこのコマンドを使う」「Windowsだとこうなる」と感じながら実行してください。",
            "MacOSユーザーはターミナルを使うことでそのまま実行可能です。",
        ],
        unindex: true,
    },
    {
        title: "②WindowsOS環境で実施する場合",
        imgPath: linuxImages[0],
        width: "260px",
        text: [
            "検索バーに「cmd」と入力し、コマンドプロンプトを起動します。",
            "「chcp△65001」と入力し、Enterキーを押します。",
            "これはUTF-8フォントで文字を扱う指定です。",
        ],
        unindex: true,
    },
    {
        title: "③MacOS環境で実施する場合",
        text: [
            "ターミナルを使うことでこのサイトに表示されている内容をそのまま実施できます。",
            "「:wq」と入力し、Enterキーを押して終了できます。",
        ],
        unindex: true,
    },
    // 各Lessonデータを設定
    {
        title: "Lesson1-ディレクトリ移動-",
        header: "➀",
        imgPath: linuxImages[1],
        text: [
            "ディレクトリ移動はLinuxコマンドと同じく「cd」を使用します。",
            "「cd△desktop」と入力してディレクトリを移動します。",
        ],
    },
    {
        title: "Lesson2-ファイル・ディレクトリ情報の表示-",
        header: "➁",
        imgPath: linuxImages[2],
        text: [
            "Windowsコマンドでは「dir」と入力します。",
            "正しく実行されればフォルダやファイ��名が表示されます。",
        ],
    },
    {
        title: "Lesson3-ファイルの時間更新・新規作成-",
        header: "➂",
        imgPath: linuxImages[3],
        text: [
            "「type△NUL△>△test.txt」と入力すると新規ファイルが作成されます。",
        ],
    },
    {
        title: "Lesson4-ファイルの編集-",
        header: "➃",
        imgPath: linuxImages[4],
        text: [
            "「notepad△test.txt」と入力するとメモ帳が起動します。",
            "任意の文字を入力して保存してください。",
        ],
    },
    {
        title: "Lesson5-ファイル内情報の確認-",
        header: "➄",
        imgPath: linuxImages[5],
        text: [
            "「type△test.txt」と入力すると保存した内容が表示されます。",
        ],
    },
    {
        title: "Lesson6-ファイル削除-",
        header: "➅",
        imgPath: linuxImages[6],
        text: [
            "「del△test.txt」と入力するとファイルが削除されます。",
            "終了時は「exit」と入力してください。",
        ],
    },  // ... 他のデータ
    {
        title: "Lesson Challenge-Lesson実施日の表示-",
        header: "➆",
        text: [
            "現在の日付と、現在の時刻を表示するそれぞれのWindowsコマンドを調べて、個別に実行してください。",
        ],
        objId: 1,
    },
];

export const dataForNo2: GuestMaterialType[] = [
    {
        title: "認知特性テスト",
        text: ["認知特性をテストします。"],
    },
    // 他のデータを追加
];
